import React from "react";
import PublicWrapper from "../../product/global/homepage/PublicWrapper";
import {
  TypographyNew,
  TextVariant,
} from "../../product/global/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMailbox } from "@fortawesome/pro-solid-svg-icons";
import styled, { useTheme } from "styled-components";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Topbar from "../topbar/Topbar";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 3em;
`;

const Confirmation = (): React.ReactElement => {
  const theme = useTheme();
  return (
    <PublicWrapper>
      <Topbar />
      <Container>
        <FontAwesomeIcon
          icon={faMailbox as IconProp}
          color={theme.colors.primary1}
          size={"3x"}
        />
        <TypographyNew
          variant={TextVariant.subtitle2}
          marginTop={"2em"}
          marginLeft={"auto"}
          marginRight={"auto"}
        >
          Vielen Dank.
        </TypographyNew>
        <TypographyNew
          variant={TextVariant.body1}
          marginTop={"1em"}
          marginLeft={"auto"}
          marginRight={"auto"}
        >
          Bitte prüfen Sie Ihr Postfach.
        </TypographyNew>
      </Container>
    </PublicWrapper>
  );
};

export default Confirmation;
